import classNames from 'classnames';
import { TranslatableBox } from '../boxes/TranslatableBox';
import classes from './AppBasicButton.module.sass';

export function AppBasicButton({ type = 'button', className, ...rest }) {
  return <TranslatableBox {...rest} as='button' className={classNames(classes.root, className)} type={type} />;
}
